import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import isNumber from 'lodash/isNumber';
import moment from 'moment';
import styled from 'styled-components';
import Colors from '../../../styles/colors';
import getCurrency from '../../../helpers/getCurrency';
import { getUserSessionIdtoken } from '../../../helpers/userSession';
import { PayButton } from '../../../styles/checkout';
import Loading from '../../../components/Loading';
import PoweredByStripe from '../../checkout/PoweredByStripe';

class _Payment2 extends Component {
  constructor(props) {
    super(props);
    const { listenerInfo = {} } = this.props || {};

    this.state = {
      paymentError: '',
      firstName: listenerInfo.firstName || '',
      lastName: listenerInfo.lastName || '',
      email: listenerInfo.email || '',
      startPaymentSubmission: false,
    };

    this.updatePropsLock = false;
    this.onSubmit = this.onSubmit.bind(this);
    this.renderProgressBar = this.renderProgressBar.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.updateProps = this.updateProps.bind(this);
    window.newUserOrSoundcast = true;
    window.confirmationEmailSent = false;
  }

  componentDidMount() {
    if (process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'staging') {
      console.log('Stripe: setting test key');
      Stripe.setPublishableKey('pk_test_BwjUV9yHQNcgRzx59dSA3Mjt');
    } else {
      Stripe.setPublishableKey('pk_live_rR36Qeypo5CrbG1FKgE1XdlL');
    }
    this.updateProps(this.props);
    if (!isEmpty(this.props.error)) {
      this.setState({ paymentError: this.props.error });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.updateProps(nextProps);
  }

  updateProps(props) {
    // set newUserOrSoundcast for mailchimp update
    const isSameUserEmail = isEqual(this.props.userInfo.email, props.userInfo.email);
    const isSameSoundcast = isEqual(this.props.soundcastID, props.soundcastID);
    if (!isSameUserEmail || !isSameSoundcast) {
      window.newUserOrSoundcast = true;
    }
  }

  handleChange(e) {
    if (e.target.value) {
      // cache values (bug #58)
      if (e.target.name === 'firstName') {
        localStorage.setItem('soundwiseSignupFName', e.target.value);
      }
      if (e.target.name === 'lastName') {
        localStorage.setItem('soundwiseSignupLName', e.target.value);
      }
      if (e.target.name === 'email') {
        localStorage.setItem('soundwiseSignupEmail', e.target.value);
      }
    }

    this.setState({ [e.target.name]: e.target.value });
  }

  async onSubmit(event) {
    event.preventDefault();
    this.setState({
      startPaymentSubmission: true,
      paymentError: null,
    }, async () => {
      try {
        let {
          sessionId,
          soundcastID: soundcastId = '',
          checked = 0,
          coupon = '',
          userInfo = null,
          listenerInfo = null,
          isMobileRequest = false,
        } = this.props;
        const { email = '' } = this.state;
        const token = await getUserSessionIdtoken(true);
        const headers = {
          ...(isEmpty(token) ? {} : { token }),
          ...(!isMobileRequest ? {} : { token2: true }),
        };
        const { data: reqData } = await Axios.post('/api/stripe-checkout/create-session', {
          soundcastId,
          ...(isEmpty(sessionId) ? {} : { sessionId }),
          ...(isNumber(checked) ? { checked } : {}),
          ...(isEmpty(coupon) ? {} : { coupon }),
          ...(isEmpty(email) ? {} : { email }),
          ...(isEmpty((userInfo || {}).id) ? {} : { userId: userInfo.id }),
          ...(isEmpty((listenerInfo || {}).email) ? {} : { listenerInfo }),
        }, {
          ...(isEmpty(headers) ? {} : { headers }),
        });
        const { success = false, data = null, errorMessage } = reqData || {};
        const {
          url: sessionUrl = null,
          id = null,
        } = data || {};
        if (success && !isEmpty(sessionUrl)) {
          const { stripe_user_id: account_id = null  } = this.props.publisher || {};

          // this replace history url w/o page relod
          const url = new URL(window.location.href);
          const updateUrlParameter = (name, value) => {
            if (isEmpty(value)) { url.searchParams.delete(name); }
            else { url.searchParams.set(name, value); }
          };
          updateUrlParameter('coupon', coupon);
          updateUrlParameter('account_id', account_id);
          updateUrlParameter('session_id', id);
          window.history.pushState(null, '', url.toString());
          // redirest to stripe session url
          return window.open(sessionUrl, `_self`);
        }
        throw new Error(errorMessage);
      } catch (err) {
        this.setState({
          startPaymentSubmission: false,
          paymentError: err.message || 'Unknown error',
        });
      }
    });
  }

  renderProgressBar() {
    return (
      <ProcessingBar>
        <Loading text="Processing" align="center" size={60} fontSize={1.6} />
      </ProcessingBar>
    );
  }

  renderPayBtn() {
    const { startPaymentSubmission: processing } = this.state;
    const btnContent = processing ? (
      <Loading
        text= {"Start payment"}
        type="circle"
        align="center"
        size={30}
        fontSize={1.6}
        color="#fff"
        fill="#fff"
      />
    ) : 'PAY NOW'; // 'PAY NOW' || 'Checkout'

    return (
      <CustomPayButton
        id="paymentPayNowBtnTest"
        className={`btn text-white width-100 ${processing ? 'disabled' : ''}`}
        type="submit"
      >
        {btnContent}
      </CustomPayButton>
    );
  }

  render() {
    const { email, firstName, lastName, paymentError } = this.state;
    const { totalPrice, hideCardInputs, soundcast, checked, isFree, isTrial, isNeedEmail } = this.props;

    // if free soundcast just process the payment
    // and showw a loading indicator
    if (isFree && !isTrial) {
      return this.renderProgressBar();
    }

    const pricing = soundcast.prices[checked];
    const currency = getCurrency(pricing);

    // location url w/o email
    const locationUrlWithOutEmail = () => {
      if (isNeedEmail) {
        const hrefUrl = new URL(window.location.href);
        hrefUrl.searchParams.delete('email');
        const { pathname = '', search = '' } = new URL(hrefUrl.toString());
        return (pathname + search) || '';
      }
      return '';
    };

    return (
      <CreditCardForm onSubmit={this.onSubmit}>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 ">
            <TotalPrice>
              <div className="total-text text-extra-large">Total</div>
              <div className="total-price-text title-small font-weight-700">{`${currency} ${Number(totalPrice).toFixed(2)}`}</div>
            </TotalPrice>
          </div>
        </div>

        {isNeedEmail && (
          <div className="row">
            <div className="col-lg-12">
              <SigninOption className="text-large font-italic">
                <span>This email address will be used for payment and when registering a new listener account. </span>
                <br/>
                <span>Already have an account? </span>
                <Link
                  to={{
                    pathname: '/signin',
                    state: { returnUrl: locationUrlWithOutEmail() },
                  }}>
                  {`Sign in >`}
                </Link>
              </SigninOption>
              <input
                  onChange={this.handleChange}
                  required
                  className="border-radius-4"
                  type="email"
                  name="email"
                  placeholder="Email"
                  style={styles.input}
                  defaultValue={email}
              />
            </div>
          </div>
        )}

        {/* <div className="row">
            <React.Fragment>
              <div className="col-lg-6 col-md-6 col-sm-12">
                <input
                  onChange={this.handleChange}
                  required
                  className="border-radius-4"
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  style={styles.input}
                  defaultValue={firstName}
                />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12">
                <input
                  onChange={this.handleChange}
                  required
                  className="border-radius-4"
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  style={styles.input}
                  defaultValue={lastName}
                />
              </div>
            </React.Fragment>
        </div> */}

        {paymentError && (
          <div className="row">
            <div className="col-lg-12 col-md-12 col-xs-12">
              <div className="alert alert-danger" role="alert">
                {paymentError}
              </div>
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-lg-12">
            {(hideCardInputs && (
              <div>
                <button
                  type="submit"
                  className="contact-submit btn propClone btn-3d text-white width-100 builder-bg tz-text"
                  style={{ ...styles.button }}
                >
                  SUBMIT
                </button>
              </div>
            )) || (
              <div>
                {this.renderPayBtn()}
                <PoweredByStripe />
              </div>
            )}
          </div>
        </div>
      </CreditCardForm>
    );
  }
}

const mapStateToProps = state => {
  return { isEmailSent: state.user.isEmailSent };
};
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);
const Payment2 = connect(
  mapStateToProps,
  mapDispatchToProps
)(_Payment2);
export default Payment2;

const SigninOption = styled.div`
  a {
    color: ${Colors.mainOrange};
  };
  padding-bottom: 15px;
`;

const TotalPrice = styled.div`
  border-top: 1px solid ${Colors.mainGrey};
  text-align: right;
  margin-bottom: 20px;

  .total-text {
    display: inline-block;
    padding-right: 15px;
  }

  .total-price-text {
    display: inline-block;
  }
`;

const CreditCardForm = styled.form`
  .card-number-wrapper {
    text-align: right;

    .card-logos {
      img {
        margin: 0 2px 5px 0;
      }
    }
  }

  .card-security {
    display: flex;
    justify-content: space-between;
  }

  .input-area {
    position: relative;

    .error-view {
      position: absolute;
      bottom: 0;
      color: #F44336;
      font-size: 1.2rem;
      left: 1px;
    }
  }

  .powered-by {
    display:flex;
    align-items: center;
    justify-content: space-between;

    .notice {
      display: flex;

      i {
        font-size: 16px;
        padding: 2px 5px 2px 0;
      }
    }

    .logo {
      background-color: #f76b1c;
      overflow: hidden;
      width: 138px;
      margin-right: -8px;
    }
  }
`;

const CustomPayButton = styled(PayButton)`
  background-color: #424242;
`;

const ProcessingBar = styled.div`
  padding: 30px 0;
`;

const styles = {
  cardsImage: {
    height: 26,
  },
  input: {
    height: 46,
    fontSize: '1.5rem',
  },
  input2: {
    height: 46,
    fontSize: 14,
    margin: '10px 0 0 0',
  },
  selectBlock: {
    // width: '100%',
    height: 46,
    border: `1px solid ${Colors.mainGrey}`,
    paddingLeft: 10,
    marginRight: '5%',
  },
  selectLabel: {
    fontWeight: 'normal',
    display: 'block',
    marginBottom: 0,
    color: Colors.fontBlack,
    fontSize: 14,
  },
  select: {
    border: 0,
    backgroundColor: Colors.mainWhite,
    padding: 0,
    margin: 0,
    color: Colors.fontGrey,
    fontSize: 14,
    position: 'relative',
    right: 3,
  },
  button: {
    height: 46,
    backgroundColor: Colors.mainOrange,
    fontSize: 14,
  },
  securedText: {
    fontSize: 14,
  },
  relativeBlock: {
    position: 'relative',
  },
};
